import type { PageLoad } from "./$types";

export const load: PageLoad = async function ({ parent }) {
  const { placeTypes } = await parent();

  return {
    placeTypes: placeTypes,
    pageTitle: "Places"
  };
};
